<div id="fade"></div>
<div id="modal">
    <img style="margin-bottom:10px;" id="loader" src="/Cache/images/icon_load.gif" /><br />
    <label><strong>Please wait while the page is processing...</strong></label>
</div>
<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">Expense Added</h3>
</div>
<div class="modal-body">

    <div *ngIf="!errorMsg||errorMsg.trim()===''">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
                You have successfully added a new expense.
            </div>
        </div>
        <div class="row" style="margin-top:10px;">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <label style="font-weight:700">Description:</label>
                <input type="text" class="form-control" [(ngModel)]="expenseData.ReceiptDescription" />
            </div>
        </div>
        <div class="row" style="margin-top:10px;">
            <div class="col-lg-3 col-md-5 col-sm-12">
                <label style="font-weight: 700">Gross Amount:</label>
                <input currencyMask type="text" [options]="options" class="form-control" [(ngModel)]="expenseData.Amount" />
            </div>
        </div>
        <div class="row" style="margin-top:10px;">
            <div class="col-lg-3 col-md-5 col-sm-12">
                <label style="font-weight:700">Transaction Date:</label>
                <div class="input-group">
                    <input type="text"
                           class="form-control"
                           bsDatepicker
                           #fromdp="bsDatepicker"
                           [(ngModel)]="expenseData.ExpenseDate"
                           [outsideClick]="true"
                           [bsConfig]="bdatePickerOptions"
                           [readonly]="mobileMode"
                           style="background-color:#ffffff">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                                (click)="fromdp.show()"
                                [attr.aria-expanded]="fromdp.isOpen"
                                style="margin-right:0px">
                            <i class="oi oi-calendar"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top:10px;" *ngIf="catList != null && catList.length > 0 && showExpenseCategory">
            <div class="col-lg-3 col-md-5 col-sm-12">
                <label style="font-weight:700">Category</label>
                <ng-select [(ngModel)]="expenseData.ExpenseCatgID"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let data of catList" [value]="data.ExpenseCatgID">{{data.ExpenseCatgName}}</ng-option>
                </ng-select>
            </div>
        </div>

        <div *ngIf="savedFiles && savedFiles.length > 0">
            <div class="row" style="margin-top:10px;">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <label style="font-weight:700">Attachments: </label>
                    <ng-select [(ngModel)]="formData.selectedAttachment"
                               bindLabel="AttachmentFileName"
                               [searchable]="false"
                               [clearable]="false"
                               dropdownPosition="bottom"
                               (ngModelChange)="getAttachmentData()">
                        <ng-option *ngFor="let data of savedFiles" [value]="data">{{data.AttachmentFileName}}</ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="row" *ngIf="attachmentData">
                <div class="col-lg-10 col-md-10 col-sm-10">
                    <app-read-only-pdf-viewer [attachment]="attachmentData" (alertCreated)="errorMsg = $event.msg"></app-read-only-pdf-viewer>
                </div>
            </div>
        </div>

    </div>
    <div *ngIf="errorMsg && errorMsg.trim()!==''">
        {{errorMsg}}
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="openEditExpenseReceipt()" *ngIf="!errorMsg||errorMsg.trim()===''">Edit Expense Info</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Close</button>
</div>
